import { useQuery } from "@tanstack/react-query";
import { executeQuery } from "../../../utils";
import { CourseGroup } from "../../../learner/types";

export const COURSE_GROUPS_QUERY_KEY = "course-groups";

export function useCourseGroupsQuery() {
  const result = useQuery<{ rows: CourseGroup[] }>({
    queryKey: [COURSE_GROUPS_QUERY_KEY],
    queryFn: () =>
      executeQuery({ path: "/manager_new/parent-portal/course-groups" }),
  });

  return {
    ...result,
    courseGroups: result.data?.rows || [],
  };
}
